export default __webpack_public_path__ + "static/Refrigerator-Deluxe-Extra-Bold-5a65044e63bfe518607921bcc349a36d.woff";